import React from 'react';

const ConsultationsPage = () => {
  return (
    <div>
      <h1>Consultations</h1>
    </div>
  );
};

export default ConsultationsPage;
